import { PlayingAnimation } from '@/components/animations/playing-animation';
import commonMessages from '@rhg/lang/messages/common';
import { Typography } from '@rhg/libs/material';
import { useIntl } from 'react-intl';

export interface NowPlayingIndicatorProps {
    title?: string;
    isPlaying: boolean;
}

/** Waveform for the track loaded in the player, with a screen-reader playing or paused status. */
export function NowPlayingIndicator({
    title,
    isPlaying,
}: NowPlayingIndicatorProps) {
    const { formatMessage } = useIntl();

    return (
        <>
            <PlayingAnimation
                isPlaying={isPlaying}
                color="info"
                size="medium"
                testId="waveform-indicator"
            />
            {/* WCAG 4.1.3 Status Messages: the waveform itself is aria-hidden,
                so this announces the state change to assistive tech. */}
            <Typography variant="srOnly" role="status" aria-live="polite">
                {formatMessage(
                    commonMessages[
                        isPlaying ? 'common.now_playing' : 'common.paused_track'
                    ],
                    { title }
                )}
            </Typography>
        </>
    );
}
